const Spacer = ({size}) => {
  return (
    <div style={{height:size + "px"}}></div>
  )
}

export default Spacer;